import * as React from 'react'
import HotspotTeaserMolecule from 'theme/molecules/HotspotTeaser'
import styled from 'styled-components'
import * as t from 'theme/molecules/HotspotTeaser/types'
import Markdown from 'theme/atoms/Markdown'
import { theme } from 'containers/GlobalStyle'
import Button from 'theme/atoms/Button'

export default function HotspotTeaser(props: t.Props) {
  return (
    <Wrapper>
      <HotspotTeaserMolecule {...props} />
      <div className="teaser-info">
        <Markdown html={props.teaserInfo || ''} />
        {!!props.buttonText && (
          // eslint-disable-next-line @kaminrunde/firescout/jsx-expression-needs-state
          <Button variation="cart" to={props.buttonLink}>
            {props.buttonText}
          </Button>
        )}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing('m')};
  > .HotspotTeaser {
    width: 100%;
  }
  > .teaser-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing('m')};
  }
  @media (min-width: ${theme.ms.LG}px) {
    flex-direction: row;
    > .HotspotTeaser {
      width: 50%;
    }
    > .teaser-info {
      width: 50%;
    }
  }
`
